<template>
  <footer class="footer">
    <div class="container">
      <div class="content has-text-centered has-text-dark">
        <p>
          <a style="padding-right: 0.7em" target="_blank" href="https://www.youtube.com/channel/UCfd4AN4UKiWyHDdq-fizQGA">
            <b-icon size="is-medium" type="is-primary" icon="youtube"></b-icon>
          </a>
          <a style="padding-right: 0.7em" target="_blank" href="https://www.facebook.com/ctechindi">
            <b-icon size="is-medium" type="is-primary" icon="facebook"></b-icon>
          </a>
          <a style="padding-right: 0.7em" target="_blank" href="https://www.instagram.com/ctechhindi">
            <b-icon size="is-medium" type="is-primary" icon="instagram"></b-icon>
          </a>
          <a style="padding-right: 0.7em" target="_blank" href="https://github.com/ctechhindi">
            <b-icon size="is-medium" type="is-primary" icon="github"></b-icon>
          </a>
          <a style="padding-right: 0.7em" target="_blank" href="https://stackoverflow.com/users/9976176/c-tech-hindi">
            <b-icon size="is-medium" type="is-primary" icon="stack-overflow"></b-icon>
          </a>
          <a style="padding-right: 0.7em" target="_blank" href="https://twitter.com/ctechindi">
            <b-icon size="is-medium" type="is-primary" icon="twitter"></b-icon>
          </a>
          <a style="padding-right: 0.7em" target="_blank" href="www.linkedin.com/in/c-tech-hindi">
            <b-icon size="is-medium" type="is-primary" icon="linkedin"></b-icon>
          </a>
        </p>
        <p>
          <a href="https://github.com/ctechhindi/YouTube-Comment-Picker/issues" target="_blank">Report Bug&nbsp;</a>|
          <router-link to="/privacy-policy">Privacy Policy&nbsp;</router-link>|
          <a href="https://github.com/ctechhindi/YouTube-Comment-Picker" target="_blank">GitHub&nbsp;</a>
        </p>
        <p class="copyright">
          Copyrights ©
          <a target="_blank" href="http://ctechhindi.in">C Tech Hindi</a> {{ new Date().getFullYear() }} | Made with
          <b-icon icon="heart" type="is-danger"></b-icon>in India
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
}
</script>